<div class="card">
  <div class="card-header d-flex align-items-center justify-content-between gap-3">
    <div class="text-semi-bold" i18n>Unit List</div>
    <div class="flex-fill"></div>
    <app-table-search (search)="onSearch($event)"></app-table-search>
    <button
      class="btn btn-secondary-primary"
      (click)="onRefresh()"
      i18n-matTooltip
      matTooltip="Refresh List"
      matTooltipPosition="above"
    >
      <i class="far fa-sync"></i>
    </button>
    <button type="button" class="btn btn-secondary-info" (click)="onAdd()">
      <i class="far fa-plus"></i> <ng-container i18n>Add Unit</ng-container>
    </button>
  </div>

  <div class="table-holder table-responsive">
    <table class="table table-default">
      <mat-table #table matSort [dataSource]="dataSource">
        <ng-container matColumnDef="unit_name_id">
          <mat-header-cell *matHeaderCellDef mat-sort-header i18n>Unit Name</mat-header-cell>
          <mat-cell *matCellDef="let element">
            {{ unitNamesById[element.unit_name_id]?.unit_name || 'Unknown' }}
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="unit_id">
          <mat-header-cell *matHeaderCellDef mat-sort-header i18n> Unit Id </mat-header-cell>
          <mat-cell *matCellDef="let element">
            {{ element.unit_id }}
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="unit_type_id">
          <mat-header-cell *matHeaderCellDef mat-sort-header i18n> Unit Type </mat-header-cell>
          <mat-cell *matCellDef="let element">
            {{ unitTypesById[element.configuration.unit_type_id]?.unit_type_name || 'Unknown' }}
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="edit">
          <mat-header-cell *matHeaderCellDef i18n> Edit </mat-header-cell>
          <mat-cell *matCellDef="let element" (click)="$event.stopPropagation()">
            <div dropdown placement="bottom right" container="body">
              <div dropdownToggle class="btn-group btn-ellips-holder">
                <a class="btn-ellips">
                  <i class="fas fa-ellipsis-v"></i>
                </a>
              </div>
              <ul *dropdownMenu class="dropdown-menu dropdown-menu-right">
                <li>
                  <button (click)="onEdit(element)" type="button">
                    <i class="fal fa-edit"></i><ng-container i18n>Edit</ng-container>
                  </button>
                </li>
                <li>
                  <button (click)="onRemove(element)" type="button">
                    <i class="cs-icon cs-icon-trash"></i><ng-container i18n>Delete</ng-container>
                  </button>
                </li>
              </ul>
            </div>
          </mat-cell>
        </ng-container>
        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns" (click)="onEdit(row)"></mat-row>
      </mat-table>
      <app-loading-section *ngIf="isLoading"></app-loading-section>
      <mat-paginator2
        #paginator
        [length]="dataSource?.data?.length"
        [class.hidden]="!dataSource?.filteredData?.length"
        [pageSize]="10"
        [pageSizeOptions]="[5, 10, 20, 50, 75, 100]"
        [showFirstLastButtons]="true"
      >
      </mat-paginator2>
      <app-empty-table *ngIf="!isLoading && isEmptyTable$ | async">
        <img class="empty-image" src="assets/images/empty_icons/bdc-unit.svg" />
        <h5 class="empty-header" i18n>Add Units to Your Property</h5>
        <p>
          <ng-container i18n
            >Break down your property into manageable units to organize rooms, track availability, and manage listings
            more efficiently.</ng-container
          >&nbsp; <a href="javascript:void(0)" (click)="onAdd()" i18n>Click here</a>&nbsp;<ng-container i18n
            >to add your first unit and start structuring your property.</ng-container
          >
        </p>
      </app-empty-table>
    </table>
  </div>
</div>
